import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation, useQueryClient } from "react-query";
import { ApiResultModel } from "../../../models/common.model";
import { DeleteCartItemResponse } from "../../models/store.model";
import { v4 as uuid } from "uuid";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
interface props {
  serviceName: any;
  openCancelModal: boolean;
  setOpenCancelModal: any;
  requestModel: any;
  setUpdateCart?: any;
  response?: any;
  handleCancel?: any;
}
export default function CancelModal({
  serviceName,
  openCancelModal,
  setOpenCancelModal,
  requestModel,
  setUpdateCart,
  response,
  handleCancel,
}: props) {
  const handleClose = () => setOpenCancelModal(false);
  const handleOpen = () => setOpenCancelModal(true);
  type MyResponseType = InstanceType<typeof response>;
  const { mutate: cancelMutation } = useMutation(serviceName, {
    onSuccess: (result: MyResponseType) => {
      if (handleCancel) {
        handleCancel(0, 0);
      }
      if (result.isSuccess === true) {
        handleClose();
        setUpdateCart(uuid());
      }
    },
  });
  const handelVerify = () => {
    cancelMutation(requestModel!);
  };
  const handelCancel = () => {
    handleClose();
  };

  return (
    <div>
      <Modal
        open={openCancelModal}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{ borderRadius: "6px", padding: "40px 70px 70px 60px" }}
          className="ModalCmp textCenter "
        >
          <div>
            <Typography className="textCenter mTop30 mbottom20">
              آیا از <b className="colorCancel">حذف کردن </b> این درخواست
              اطمینان دارید؟
            </Typography>
          </div>
          <Grid container spacing={2} columns={16} className="mTop20">
            <Grid item xs={8}>
              <Button
                onClick={handelVerify}
                fullWidth
                className="btnForm DangerDefault"
              >
                حذف
              </Button>
            </Grid>
            <Grid item xs={8}>
              <Button
                onClick={handelCancel}
                fullWidth
                className="btnForm ComingBack"
              >
                انصراف
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
